import { RecordTypesTransaction } from '../enums/audit-trail.enum';
import { OptionDescription } from '../types/option.type';
import { IAuditTrailAlignField } from "../interfaces";


export function fieldNameAgent(type: string,): { [key: string]: string } {
  return {
    [`${type}.pdRole`]: 'Type',
    [`${type}.type`]: type === 'referrals' ? 'Referral Type' : 'Type',
    [`${type}.appTypeCode`]: 'Session',
    [`${type}.formula`]: 'Type',
    [`${type}.agent.name`]: 'Comm Person',
    [`${type}.receivedValue`]: 'Comm Amount',
    [`${type}.tiers.0.salesperson.businessName`]: 'Main Agent > Business Name',
    [`${type}.tiers.0.salesperson.ceaRegNo`]: 'Main Agent > CEA Reg No',
    [`${type}.tiers.0.percentage`]: 'Main Agent > Comm Scheme',
    [`${type}.tiers.0.value`]: 'Main Agent > Comm Amount',
    [`${type}.tiers.1.salesperson.businessName`]: 'Tier 1 Business Name',
    [`${type}.tiers.1.salesperson.ceaRegNo`]: 'Tier 1 CEA Reg No',
    [`${type}.tiers.1.value`]: 'Tier 1 Amount',
    [`${type}.tiers.2.salesperson.businessName`]: 'Tier 2 Business Name',
    [`${type}.tiers.2.salesperson.ceaRegNo`]: 'Tier 2 CEA Reg No',
    [`${type}.tiers.2.value`]: 'Tier 2 Amount',
    [`${type}.parties.0.salesperson.businessName`]: 'Recruiter Business Name',
    [`${type}.parties.0.salesperson.ceaRegNo`]: 'Recruiter CEA Reg No',
    [`${type}.parties.0.value`]: 'Recruiter Amount',
  }
};

export function fieldHideAgent(type: string): string[] {
  return [
    `${type}.tiers.0.salesperson.id`,
    `${type}.tiers.0.salespersonId`,
    `${type}.tiers.1.salesperson.id`,
    `${type}.tiers.1.salespersonId`,
    `${type}.tiers.1.percentage`,
    `${type}.tiers.2.salesperson.id`,
    `${type}.tiers.2.salespersonId`,
    `${type}.tiers.2.percentage`,
    `${type}.parties.0.salesperson.id`,
    `${type}.parties.0.salespersonId`,
    `${type}.parties.0.percentage`,
    `${type}.agent.id`,
    `${type}.agent.code`,
  ];
};
export const generalFieldsHide = [
  'businessUnitId',
  'company.id',
  'company.code',
  'metadata',
  'metadata.admin',
  'metadata.agent',
  'metadata.isFirstTimeSubmitted',
  'metadata.isAbleSubmitted',
  'country.id',
  'country.code',
  'relatedAgent.mains.agent.id',
  'relatedAgent.internals.agent.id',
  'relatedAgent.externals.contact.id',
  'relatedAgent.externals.contact.code',
  'relatedAgent.mains.absorbType.full',
  'relatedAgent.internals.absorbType.full',
  'relatedAgent.externals.contact.id',
  'relatedAgent.externals.contact.code',
  'relatedAgent.externals.grossComm.subAmount',
  'relatedAgent.externals.grossComm.amount',
  'relatedAgent.externals.grossComm.subTotalAmount',
  'relatedAgent.externals.grossComm.includeGst',
  'relatedAgent.externals.grossComm.taxType',
  'relatedAgent.externals.grossComm.taxValue',
  'relatedAgent.externals.grossComm.currency',
  'relatedAgent.externals.grossComm.grossType',
  'relatedAgent.externals.grossComm.gstType',
  'relatedAgent.externals.grossComm.isStupidFollow',

  //team Project Consultant 
  'team.id',
  'salesperson.id',
  'absorbType.full',
  'agent.id',
  'absorbType',

  // hi tab
  'isPersonInCharge',

  // comm matrix
  'otherFund.agent',
  'otherFund.hr',
  'commissionType.id',
  'icOverriding.disOverridingId',
  'icBonus.disBonusId',
  'startDateMarketing',
  'endDateMarketing',
  'commissionType.code',
  'headHi.disOverridingId',
  'bd.disOverridingId',
  'hiProfit.agent',
  'hiProfit.hr',

  // project setup
  'district.id',
  'district.code',
  'entity',
  'managementComm.id',
  'managementComm.name',
  'developer.id',
  // mana comm
  'relatedPd',
  'relatedPd.pdOverride.additional',
  'relatedPd.pdReferral.additional',
  'relatedPd.pdManagement.additional',
  'additional',
  'relatedPd.pdOverride.entityName',
  'relatedPd.pdReferral.entityName',
  'relatedPd.pdManagement.entityName',
  //transaction
  'currencyCode',
  'projectCommission.id',
  'projectCommInternational.id',
  'projectCommInternational',
  'projectCommission.code',
  'projectCommInternational.code',
  'grossComm.subAmount',
  'grossComm.amount',
  'grossComm.includeGst',
  'grossComm.taxType',
  'grossComm.taxValue',
  'grossComm.currency',
  'grossComm.grossType',
  'grossComm.gstType',
  'grossComm.rebateAmount',
  'devGrossComm.subAmount',
  'devGrossComm.includeGst',
  'devGrossComm.taxType',
  'devGrossComm.taxValue',
  'devGrossComm.currency',
  'devGrossComm.grossType',
  'devGrossComm.gstType',
  'devGrossComm.rebateAmount',
  'hiGrossComm.subAmount',
  'hiGrossComm.includeGst',
  'hiGrossComm.taxType',
  'hiGrossComm.taxValue',
  'hiGrossComm.currency',
  'hiGrossComm.grossType',
  'hiGrossComm.gstType',
  'hiGrossComm.rebateAmount',
  'profomaGrossComm.subAmount',
  'profomaGrossComm.amount',
  'profomaGrossComm.includeGst',
  'profomaGrossComm.taxType',
  'profomaGrossComm.taxValue',
  'profomaGrossComm.taxAmount',
  'profomaGrossComm.currency',
  'profomaGrossComm.grossType',
  'profomaGrossComm.gstType',
  'profomaGrossComm.rebateAmount',
  'relatedAgent.main.agent.id',
  'relatedAgent.main.team.id',
  'relatedAgent.main.transacted.cashAdvance.absorbType.full',
  'relatedAgent.main.transacted.buyerRebate.absorbType.full',
  'relatedAgent.main.transacted.powerDiscount.value',
  'relatedAgent.main.transacted.powerDiscount.percent',
  'relatedAgent.main.transacted.powerDiscount.absorbType.agent',
  'relatedAgent.main.transacted.powerDiscount.absorbType.hr',
  'relatedAgent.main.transacted.powerDiscount',

  'relatedAgent.internals.agent.id',
  'relatedAgent.internals.team.id',
  'relatedAgent.internals.transacted.cashAdvance.absorbType.full',
  'relatedAgent.internals.transacted.buyerRebate.absorbType.full',
  'relatedAgent.internals.transacted.powerDiscount.value',
  'relatedAgent.internals.transacted.powerDiscount.percent',
  'relatedAgent.internals.transacted.powerDiscount.absorbType.agent',
  'relatedAgent.internals.transacted.powerDiscount.absorbType.hr',
  'relatedAgent.internals.transacted.powerDiscount',

  'relatedAgent.externals.agent.id',
  'relatedAgent.externals.transacted.cashAdvance.absorbType.full',
  'relatedAgent.externals.transacted.buyerRebate.absorbType.full',
  'relatedAgent.externals.transacted.powerDiscount.value',
  'relatedAgent.externals.transacted.powerDiscount.percent',
  'relatedAgent.externals.transacted.powerDiscount.absorbType.agent',
  'relatedAgent.externals.transacted.powerDiscount.absorbType.hr',
  'relatedAgent.externals.transacted.powerDiscount',

  'relatedAgent.leaders.agent.id',
  'relatedAgent.leaders.team.id',
  'relatedAgent.leaders.teamType',
  'relatedAgent.leaders.grouping',
  'buyers.transactionCode',
  'buyers.blankFormCode',
  'buyers.marital.id',
  'buyers.maritalId',
  'buyers.marital.code',
  'marital.id',
  'maritalId',
  'marital.code',
  'districtId',
  'buyers.districtId',
  'bonuses.salesperson.id',
  'bonuses.salespersonId',
  'overridings.salesperson.id',
  'overridings.salespersonId',
  'pools.salesperson.id',
  'pools.salespersonId',
  'bds.salesperson.id',
  'bds.salespersonId',
  'pds.salesperson.id',
  'pds.salespersonId',
  'pds.additional',
  'bdExternals.contact.id',
  'bdExternals.contactId',
  'bdExternals.contact.code',
  'bdExternals.appTypeCode',
  'bdExternals.transacted.discount.absorbType.agent',
  'bdExternals.transacted.discount.absorbType.hr',
  'bdExternals.transacted.discount.absorbType.full',
  'bdExternals.transacted.incentive.absorbType.agent',
  'bdExternals.transacted.incentive.absorbType.hr',
  'bdExternals.transacted.incentive.absorbType.full',
  'referrals.salesperson.id',
  'referrals.agentId',
  'referrals.salespersonId',
  'referrals.absorbType.full',

  // blank form
  ...fieldHideAgent('relatedAgent.mains'),
  ...fieldHideAgent('relatedAgent.internals'),
  ...fieldHideAgent('relatedAgent.leaders'),
  ...fieldHideAgent('bds'),
  ...fieldHideAgent('bonuses'),
  ...fieldHideAgent('overridings'),
  ...fieldHideAgent('pools'),
  ...fieldHideAgent('pds'),
  ...fieldHideAgent('referrals'),
  'others.code',
  'buyers.blankFormCode',
  'buyers.maritalId',
  'buyers.districtId',
  'address.addressDisplay',
  'buyers.address.addressDisplay',
  'relatedAgent.mains.attrs.splitForMainInvalid',
  'relatedAgent.main.attrs.splitForMainInvalid',
  'relatedAgent.internals.attrs.splitForMainInvalid',
  'submittedBy.id'
];

export const fieldNameMapUnit: { [key: string]: string } = {
  'projectCode': 'Project Code',
  'unitNo': 'Unit No',
  'blkNo': 'Block No',
  'unitType': 'Unit Type',
  'noOfRoom': 'No Of Room',
  'areaSqft': 'Area Sqft',
  'areaSqm': 'Area Fqm',
  'psf': 'PSF',
  'isExcludeReport': 'Checkbox : Exclude the unit in project status report',
  'postalCode': 'Postal Code',
  'sellingPrice': 'Selling Price',
  'bookingFee': 'Booking Fee',
};

export const resaleFieldsHide = [
  // 'propertyAddress.country',
  'agreementDate',
  'relatedAgent.externals.brokerEmail',
  'relatedAgent.externals.gstType',
  'relatedAgent.mains.attrs.splitForMainInvalid',
  'relatedAgent.internals.attrs.splitForMainInvalid',
  'billing.contact.id',
  'billing.contact.code',
  'billing.choosenAddress.id',
  'billing.choosenAddress.address',
  'billing.billingCountry.id',
  'billing.billingCountry.code',
  'billing.billingCountry.name',

  'billing.billingAddress.id',
  'billing.billingAddress.postal',
  'billing.billingAddress.state',
  'billing.billingAddress.city',
  'billing.clientCountry.id',
  'billing.clientCountry.code',
  'billing.grossComm.subAmount',
  'billing.grossComm.includeGst',
  'billing.grossComm.taxType',
  'billing.grossComm.taxValue',
  'billing.grossComm.currency',
  'billing.grossComm.grossType',
  'billing.grossComm.gstType',
  'billing.grossComm.isStupidFollow',
  'billing.commission',
  'billing.commission.type',
  'billing.commission.value',
  'billing.subAmount',
  'billing.clientAddress.noOfRooms',
  'billing.clientAddress.unit',
  'billing.clientAddress.floor',
  'billing.clientAddress.building',
  'billing.clientAddress.noOfRooms',
  'billing.clientAddress.block',
  'billing.clientAddress.street',
  'billing.clientAddress.district',
  'billing.clientAddress.state',
  'billing.clientAddress.city',
  'billing.billingAddress.noOfRooms',
  'billing.ecdds.id',
  'documents.url',
  'paymentEmailStatus'

];

export const fieldNameMapResale: { [key: string]: string } = {
  'id': 'ID',
  'code': 'Resale Code',
  'name': 'Name',
  'isActive': 'Status',
  'status': 'Status',
  'effectiveDate': 'Effective Date',
  'createdAt': 'Created At',
  'createdBy': 'Created By',
  'updatedAt': 'Updated At',
  'updatedBy': 'Updated By',
  'deletedAt': 'Deleted At',
  'deletedBy': 'Deleted By',
  'uploadedAt': 'Uploaded At',
  'uploadedBy': 'Uploaded By',
  'description': 'Description',
  'type': 'Type',
  'resaleType': 'Resale Type',
  'propertyType': 'Property Type',
  'company.code': 'Company Code',
  'company.name': 'Company',
  'isInternal': 'NV',
  'optionDate': 'Option Date / Agreement Date',
  'exerciseDate': 'Exercise Date',
  'agreementDate': 'Agreement Date',
  'commencementDate': 'Commencement Date',
  'completionDate': 'Completion Date',
  'billingDate': 'Billing Alert Date',
  'billing.billingDate': 'Billing Alert Date',
  'expireDate': 'Expire Date',
  'submissionDate': 'Submission Date',
  'reSubmissionDate': 'Resubmission Date',
  'completeDate': 'Complete Date',
  'remarks': 'Remarks (W / Agt)',
  'remarksInternal': 'Remarks Internal',
  'metadata': 'Metadata',
  'metadata.isWithPayment': 'Submission with Payment',
  'metadata.ecbGreaterPercentReason': 'Reason why ECB comm split is more than 50%',
  'metadata.isPC': 'P-Docs',
  'metadata.isCompleteDocs': 'Complete P-Docs',
  'metadata.isPendingDCDD': 'P-ICB DCDD',
  'metadata.isCompleteDCDD': 'Complete P-ICB DCDD',
  'metadata.isCobroke': 'Payout to Co-broke',
  'metadata.skipEmail': 'Skip sending email',
  'metadata.emailStatus': 'Email Status',
  'metadata.submitLateReason.type': 'Late submission type',
  'metadata.submitLateReason.reason': 'Late submission reason',
  'metadata.totalEmailDcddSent': 'Number of ICB DCDD Email’s Sent',
  'emails': 'ICB’s email',
  'remarksEmail': 'Remarks',
  'country.id': 'Country Id',
  'country.code': 'Country Code',
  'country.name': 'Country Name',
  'propertyAddress.address': 'Property Details > Address',
  'propertyAddress.country': 'Property Details > Country',
  'propertyAddress.postal': 'Property Details > Postal Code',
  'propertyAddress.unit': 'Property Details > Unit',
  'propertyAddress.floor': 'Property Details > Floor',
  'propertyAddress.building': 'Property Details > Building',
  'propertyAddress.noOfRooms': 'Property Details > No of Rooms',
  'propertyAddress.block': 'Property Details > Block',
  'propertyAddress.street': 'Property Details > Street',
  'propertyAddress.district': 'Property Details > District',
  'propertyAddress.state': 'Property Details > State',
  'propertyAddress.city': 'Property Details > City',
  'area.areaSqft': 'AreaSqft',
  'area.areaSqm': 'AreaSqm',
  'area.landSqft': 'LandSqft',
  'area.landSqm': 'LandSqm',
  'furnished': 'Furnished',

  'billing.transactionAmount': 'Billing Info > Transacted Price',
  'billing.valuationPrice': 'Billing Info > Valuation Price',

  'billing.paymentAdvice': 'Billing Info > Payment Advice For',
  'billing.clientType': 'Billing Info > To Bill',
  'metadata.isBillToAll': 'Billing Info > Bill To All',
  'billing.billingParty': 'Billing Info > Billing Party',
  'billing.contact.name': 'Billing Info > Bill To Name / Company',
  'metadata.isPropertyAddress': 'Billing Info > Same Address As Transacted Property',
  'billing.choosenAddress': 'Billing Info > Address',
  'billing.choosenAddress.address': 'Billing Info > Address',
  'billing.billingCountry.name': 'Billing Info > Billing Country',
  'billing.billingAddress': 'Billing Info > Billing Address',
  'billing.billingAddress.address': 'Billing Info > Billing Address',
  'billing.billingAddress.country': 'Billing Info > Billing Country',
  'billing.billingAddress.postcode': 'Billing Info > Billing Postcode',
  'billing.billingAddress.postal': 'Billing Info > Billing Postal',
  'billing.billingAddress.unit': 'Billing Info > Billing Unit',
  'billing.billingAddress.floor': 'Billing Info > Billing Floor',
  'billing.billingAddress.building': 'Billing Info > Billing Building',
  'billing.billingAddress.block': 'Billing Info > Billing Block',
  'billing.billingAddress.street': 'Billing Info > Billing Street',
  'billing.billingAddress.district': 'Billing Info > Billing District',
  'billing.billingAddress.noOfRooms': 'Billing Info > Billing No Of Rooms',
  'billing.remarks': 'Billing Info > Billing Remarks',

  'billing.envDelivery': 'Billing Info > Inv Delivery',
  'billing.attention': 'Billing Info > Attention',
  'billing.invoiceOption.agent.isChoosen': 'Billing Info > Invoice to be email to agent (Default)',
  'billing.invoiceOption.ecb.isChoosen': 'Billing Info > Invoice to ECB; To CC Agent (Optional)',
  'billing.invoiceOption.client.isChoosen': 'Billing Info > Invoice to be email to client; To CC Agent (Optional)',
  'billing.invoiceOption.solicitor.isChoosen': 'Billing Info > Invoice to be email to solicitor; To CC Agent (Optional)',
  'billing.invoiceOption.hardcopy.isChoosen': 'Billing Info > To send hardcopy invoice by post (Optional)',
  'billing.invoiceOption.agent.email': 'Billing Info > Invoice to be email to agent (Default) > Mail',
  'billing.invoiceOption.ecb.email': 'Billing Info > Invoice to ECB; To CC Agent (Optional) > Mail',
  'billing.invoiceOption.client.email': 'Billing Info > Invoice to be email to client; To CC Agent (Optional) > Mail',
  'billing.invoiceOption.solicitor.email': 'Billing Info > Invoice to be email to solicitor; To CC Agent (Optional) > Mail',
  'billing.invoiceOption.hardcopy.email': 'Billing Info > To send hardcopy invoice by post (Optional) > Mail',

  'metadata.isContactAddress': 'Billing Info > Client Info > Same As Billing Info',
  'billing.clientName': 'Billing Info > Client Info > Name/Company',
  'billing.clientNric': 'Billing Info > Client Info > NRIC No',
  'billing.ecddRef': 'Billing Info > Client Info > E-CDD HiP Reference Number',
  'metadata.isCounterparty': 'Billing Info > Client Info > Is the counterparty represented by a RES?',
  'billing.ecdds': 'Billing Info > Client Info > ECDD',
  'billing.ecdds.documentTitle': 'E-CDD Reference Number',
  'billing.ecdds.customers?.[0]?.name': 'E-CDD Reference Number',

  'billing.clientContact': 'Billing Info > Client Info > Contact',
  'billing.clientContact.countryCode': 'Billing Info > Client Info > Contact > Country Code',
  'billing.clientContact.phoneNumber': 'Billing Info > Client Info > Contact > Phone Number',
  'billing.clientEmail': 'Billing Info > Client Info > Client Email',
  'billing.clientCountry.name': 'Billing Info > Client Info > Country',
  'billing.clientAddress.address': 'Billing Info > Client Info > Address',
  'billing.clientAddress.postal': 'Billing Info > Client Info > Postal',

  'billing.gstCategory': 'Billing Info > Agreed Commission > GST Category',
  'billing.percentage': 'Billing Info > Agreed Commission > Percentage (%)',
  'billing.gstType': 'Billing Info > Agreed Commission > GST Type',
  'billing.gstPercent': 'Billing Info > Agreed Commission > GST (%)',
  'billing.grossComm.amount': 'Billing Info > Agreed Commission > Comm Value',
  'billing.grossComm.subTotalAmount': 'Billing Info > Agreed Commission > Billing Value',
  'billing.grossComm.totalAmount': 'Billing Info > Agreed Commission > Total Bill',
  'billing.grossComm.taxAmount': 'Billing Info > Agreed Commission > GST Amount',

  'relatedAgent.mains': 'Huttons Agent > Closing Agent',
  'relatedAgent.mains.agent.id': 'Agent ID',
  'relatedAgent.mains.agent.businessName': 'Business Name',
  'relatedAgent.mains.agent.ceaRegNo': 'CEA Reg No',
  'relatedAgent.mains.absorbType.agent': 'Scheme Agent',
  'relatedAgent.mains.absorbType.hr': 'Scheme HR',
  'relatedAgent.mains.absorbType.full': 'Scheme full',
  'relatedAgent.mains.representing': 'Representing',
  'relatedAgent.mains.attrs.splitForORInvalid': 'Split Comm Manager',
  'relatedAgent.mains.receivedPercent': 'Total Comm Receive (%)',
  'relatedAgent.mains.receivedValue': 'Total Value Receive',
  'relatedAgent.mains.ecddCodes': 'DCDD Ref. No',
  'relatedAgent.mains.ecddCodes.code': 'DCDD Ref. No',

  'relatedAgent.internals': 'Huttons Agent > Internal Co-broke',
  'relatedAgent.internals.agent.id': 'Agent ID',
  'relatedAgent.internals.agent.businessName': 'Business Name',
  'relatedAgent.internals.agent.ceaRegNo': 'CEA Reg No',
  'relatedAgent.internals.absorbType.agent': 'Scheme Agent',
  'relatedAgent.internals.absorbType.hr': 'Scheme HR',
  'relatedAgent.internals.absorbType.full': 'Scheme full',
  'relatedAgent.internals.representing': 'Representing',
  'relatedAgent.internals.attrs.splitForORInvalid': 'Split Comm Manager',
  'relatedAgent.internals.receivedPercent': 'Total Comm Receive (%)',
  'relatedAgent.internals.receivedValue': 'Total Value Receive',
  'relatedAgent.internals.ecddCodes': 'DCDD Ref. No',
  'relatedAgent.internals.ecddCodes.code': 'DCDD Ref. No',

  'relatedAgent.externals': 'External',
  'relatedAgent.externals.contact.id': 'Contact Id',
  'relatedAgent.externals.contact.code': 'Contact Code',
  'relatedAgent.externals.contact.name': 'Company Name',
  'relatedAgent.externals.brokerIdNo': 'Co-Broker ID',
  'relatedAgent.externals.brokerName': 'Co-Broker Name	',
  'relatedAgent.externals.brokerPhone.countryCode': 'Co-Broker Contact > Country Code',
  'relatedAgent.externals.brokerPhone.phoneNumber': 'Co-Broker Contact > Phone Number',
  'relatedAgent.externals.representing': 'Representing',
  'relatedAgent.externals.grossComm.totalAmount': 'Total Inv Amount',
  'relatedAgent.externals.grossComm.taxAmount': 'GST Amount',
  'relatedAgent.externals.receivedPercent': 'Comm Received (%)',
  'relatedAgent.externals.receivedValue': 'Value Received',
  'relatedAgent.externals.remarks': 'Remarks',
  'relatedAgent.externals.type': 'Status',
  'documents': 'Documents',
  'documents.name': 'Name',
  'documents.type': 'Type',
  'documents.size': 'Size',
  'paymentMethod': 'Payment Method',
  'billing.chequeDate': 'Drop Cheque Date / Time',

};

export const resaleAdjFieldsHide = [
  'resaleId',
  'grossComm.taxType',
  'grossComm.gstType',
  'grossComm.amount',
  'grossComm.taxValue',
  'grossComm.totalAmount',
  'relatedAgent.externals.grossComm.rebateAmount',

  'relatedAgent.mains.receivedPercent',
  'relatedAgent.mains.receivedValue',
  'relatedAgent.internals.receivedPercent',
  'relatedAgent.internals.receivedValue',
  'relatedAgent.mains.agent.id',
  'relatedAgent.mains.agent.businessName',
  'relatedAgent.mains.agent.ceaRegNo',
  'relatedAgent.internals.agent.id',
  'relatedAgent.internals.agent.businessName',
  'relatedAgent.internals.agent.ceaRegNo',

  'relatedAgent.mains.tiers.0.salesperson.id',
  'relatedAgent.mains.tiers.1.salesperson.id',
  'relatedAgent.mains.tiers.1.percentage',
  'relatedAgent.mains.tiers.2.salesperson.id',
  'relatedAgent.mains.tiers.2.percentage',
  'relatedAgent.mains.parties.0.salesperson.id',
  'relatedAgent.mains.parties.0.percentage',

  'relatedAgent.internals.tiers.0.salesperson.id',
  'relatedAgent.internals.tiers.1.salesperson.id',
  'relatedAgent.internals.tiers.1.percentage',
  'relatedAgent.internals.tiers.2.salesperson.id',
  'relatedAgent.internals.tiers.2.percentage',
  'relatedAgent.internals.parties.0.salesperson.id',
  'relatedAgent.internals.parties.0.percentage',


];
export const fieldNameMapResaleAdj: { [key: string]: string } = {
  'id': 'ID',
  'code': 'Transaction Code',
  'resaleCode': 'Transaction Ref',
  'isActive': 'Status',
  'status': 'Status',
  'submissionDate': 'Submission Date',
  'remarks': 'Remarks',
  'grossComm.amount': 'Agreed Commission > Billing Value',
  'grossComm.taxValue': 'Agreed Commission > GST',
  'grossComm.totalAmount': 'Agreed Commission > Total Bill',

  'relatedAgent.externals': 'External',
  'relatedAgent.externals.contact.id': 'Contact Id',
  'relatedAgent.externals.contact.code': 'Contact Code',
  'relatedAgent.externals.contact.name': 'Company Name',
  'relatedAgent.externals.grossComm.totalAmount': 'Total Inv Amount',
  'relatedAgent.externals.grossComm.taxAmount': 'GST Portion',
  'relatedAgent.externals.receivedPercent': 'Comm Received (%)',
  'relatedAgent.externals.receivedValue': 'Value Received',

  'relatedAgent.mains': 'Huttons Agent > Closing Agent',
  'relatedAgent.mains.tiers.0.salesperson.businessName': 'Main Agent > Business Name',
  'relatedAgent.mains.tiers.0.salesperson.ceaRegNo': 'Main Agent > CEA Reg No',
  'relatedAgent.mains.tiers.0.percentage': 'Main Agent > Comm Scheme',
  'relatedAgent.mains.tiers.0.value': 'Main Agent > Comm Amount',
  'relatedAgent.mains.tiers.1.salesperson.businessName': 'Tier 1 Business Name',
  'relatedAgent.mains.tiers.1.salesperson.ceaRegNo': 'Tier 1 CEA Reg No',
  'relatedAgent.mains.tiers.1.value': 'Tier 1 Amount',
  'relatedAgent.mains.tiers.2.salesperson.businessName': 'Tier 2 Business Name',
  'relatedAgent.mains.tiers.2.salesperson.ceaRegNo': 'Tier 2 CEA Reg No',
  'relatedAgent.mains.tiers.2.value': 'Tier 2 Amount',
  'relatedAgent.mains.parties.0.salesperson.businessName': 'Recruiter Business Name',
  'relatedAgent.mains.parties.0.salesperson.ceaRegNo': 'Recruiter CEA Reg No',
  'relatedAgent.mains.parties.0.value': 'Recruiter Amount',

  'relatedAgent.internals': 'Huttons Agent > Internal Co-broke',
  'relatedAgent.internals.tiers.0.salesperson.businessName': 'Main Agent > Business Name',
  'relatedAgent.internals.tiers.0.salesperson.ceaRegNo': 'Main Agent > CEA Reg No',
  'relatedAgent.internals.tiers.0.percentage': 'Main Agent > Comm Scheme',
  'relatedAgent.internals.tiers.0.value': 'Main Agent > Comm Amount',
  'relatedAgent.internals.tiers.1.salesperson.businessName': 'Tier 1 Business Name',
  'relatedAgent.internals.tiers.1.salesperson.ceaRegNo': 'Tier 1 CEA Reg No',
  'relatedAgent.internals.tiers.1.value': 'Tier 1 Amount',
  'relatedAgent.internals.tiers.2.salesperson.businessName': 'Tier 2 Business Name',
  'relatedAgent.internals.tiers.2.salesperson.ceaRegNo': 'Tier 2 CEA Reg No',
  'relatedAgent.internals.tiers.2.value': 'Tier 2 Amount',
  'relatedAgent.internals.parties.0.salesperson.businessName': 'Recruiter Business Name',
  'relatedAgent.internals.parties.0.salesperson.ceaRegNo': 'Recruiter CEA Reg No',
  'relatedAgent.internals.parties.0.value': 'Recruiter Amount',

};

export const fieldNameMapSetup: { [key: string]: string } = {
  'id': 'ID',
  'code': 'Code',
  'name': 'Name',
  'team.name': 'Group Name',
  'projectCode': 'Project Code',
  'projectName': 'Project Name',
  'team.projectCode': 'Project Code',
  'team.projectName': 'Project Name',
  'managementCommCode': 'Management Comm',
  'type': 'Type',
  'entityName': 'Type',
  'isDefault': 'Default',
  'isActive': 'Active',
  'status': 'Status',
  'description': 'Description',
  'remarks': 'Remarks',
  'configs': 'Configs',
  'configs.name': 'Name',
  'configs.isActive': 'Status',
  'bonusCharts': 'Bonus Charts',
  'bonusCharts.l1Percent': 'L1 Percentage Split (%)',
  'bonusCharts.appTypeCode': 'Appointment Type Code',
  'overridingCharts': 'Overriding Charts',
  'overridingCharts.l1Percent': 'L1 Percentage Split (%)',
  'overridingCharts.icWeightage': 'IC Weightage',
  'overridingCharts.poolWeightage': 'Pool Weightage',
  'overridingCharts.appTypeCode': 'Appointment Type Code',

  'salesperson.businessName': 'Project In-Charge > Business Name',
  'salesperson.ceaRegNo': 'Project In-Charge > CEA Reg No',
  'isMainProjectIC': 'Main Project IC',
  'isLeader': 'Group Leader',
  'startDate': 'Start Date',
  'endDate': 'End Date',
  'appTypes': 'Appointment Type',
  'appTypeCode': 'Appointment Type Code',
  'appTypes.appTypeCode': 'Code',
  'appTypes.appTypeName': 'Name',
  'appTypes.name': 'Name',
  'tiers': 'Comm Scheme',
  'parties': 'Comm Scheme',
  'tiers.name': 'Name',
  'tiers.percentage': 'Value',
  'parties.name': 'Name',
  'parties.percentage': 'Value',
  'agent.code': 'Member Code',
  'agent.name': 'Member Name',
  'formula': 'Formula',
  'fee': 'Referral Fee',
  'absorbType.agent': 'Scheme Agent',
  'absorbType.hr': 'Scheme HR',
  'absorbType.full': 'Scheme full',

  // mana comm
  'updatedBy': 'Requestor',
  'submittedAt': 'Submitted On',
  'relatedPd.pdOverride': 'PD Override',
  'relatedPd.pdOverride.entityName': ' Name',
  'activePdOverride': 'PD Override > Active',
  'relatedPd.pdOverride.appTypeCode': 'Appointment Type',
  'relatedPd.pdOverride.percentage': 'Percentage',
  'relatedPd.pdReferral': 'PD Referal',
  'relatedPd.pdReferral.entityName': 'Name',
  'activePdReferal': 'PD Referal > Active',
  'relatedPd.pdReferral.appTypeCode': 'Appointment Type',
  'relatedPd.pdReferral.percentage': 'Percentage',
  'relatedPd.pdManagement': 'PD Management',
  'relatedPd.pdManagement.entityName': 'Name',
  'activePdManagement': 'PD Management > Active',
  'relatedPd.pdManagement.appTypeCode': 'Appointment Type',
  'relatedPd.pdManagement.percentage': 'Percentage',
  'percentage': 'Percentage',

};

export const fieldNameMapTeam = {
  'salesperson.businessName': 'Member Business Name',
  'salesperson.ceaRegNo': 'Member CEA Reg No',
}

export const fieldNameMapProject: { [key: string]: string } = {
  'id': 'ID',
  'code': 'Project Code',
  'projectCode': 'Project Code',
  'name': 'Project Name',
  'reference': 'DCDD Project Name',
  'isActive': 'Active',
  'status': 'Status',
  'company.name': 'Company',
  'address': 'Project Address',
  'district.name': 'District',
  'country.name': 'Country',
  'type': 'Project Type',
  'saleType': 'Sale Type',
  'tenure': 'Tenure',
  'tenureYear': 'Tenure Year(s)',

  'paymentDueDate': 'Payment Due Date',
  'paymentByDeveloper': 'Payment by Developer',
  'gstCategory': 'GST Category',
  'gstPercentage': 'GST Percentage',

  'managementComm': 'Management Comm',
  'managementComm.code': 'Code',
  'salesperson.businessName': 'Project In-Charge > Business Name',
  'salesperson.ceaRegNo': 'Project In-Charge > CEA Reg No',
  'appTypes': 'Appointment Type',
  'appTypes.code': 'Code',
  'appointmentType.code': 'Code',
  'appTypeCode': 'Appointment Type Code',
  'appTypes.appTypeCode': 'Code',
  'appTypes.appTypeName': 'Name',
  'appTypes.name': 'Name',

  'remarks': 'Remarks',
  'developer': 'Developer',
  'developerCode': 'Developer Code',
  'developer.code': 'Developer Code',
  'developer.name': 'Developer Name',
  'developer.addresses': 'Developer Addresses',
  'developer.email': 'Developer Email',
  'developer.phone': 'Developer Phone',
  'developer.phone.countryCode': 'Developer Phone > Country Code',
  'developer.phone.phoneNumber': 'Developer Phone > Phone Number',
  'developer.category.name': 'Contact Category',
  'developer.type': 'Customer/Supplier',

};

export const fieldNameMapProjectCommission: { [key: string]: string } = {
  'id': 'ID',
  'code': 'Code',
  'name': 'Comm Matrix',
  'projectCode': 'Project Code',
  'projectName': 'Project Name',
  'projectStage': 'Project Stage',
  'type': 'Type',
  'company.name': 'Company',
  'company.code': 'Company Code',
  'commissionType.name': 'Comm Matrix Type',
  'commissionType.code': 'Comm Matrix Type',
  'isActive': 'Active',
  'status': 'Status',
  'isLocked': 'Locked',
  'description': 'Description',
  'isSpecial': 'Special',
  'unitNo': 'Unit No',

  'startDate': 'Start Date',
  'endDate': 'End Date',
  'developerTier': 'Developer Comm (%)',
  'agentTier': 'Agent Tier / HI Tier (%)',
  'companyTier': 'Company Tier / HA Tier (%)',
  'remarks': 'Remarks',

  'closingAgent.value': 'Closing Agent (%)',
  'closingAgent.agent': 'Closing Agent > Scheme Agent',
  'closingAgent.hr': 'Closing Agent > Scheme HR',
  'teamLeader.value': 'Group Leader (%)',
  'teamLeader.agent': 'Group Leader >  Scheme Agent',
  'teamLeader.hr': 'Group Leader > Scheme HR',
  'otherFund.value': 'Marketing Fund (%)',

  'icBonus.value': 'IC Bonus (%)',
  'icBonus.disBonus.disBonusCode': 'IC Bonus Distribution',
  'icBonus.disBonusCode': 'IC Bonus Distribution',
  'icBonus.agent': 'IC Bonus >  Scheme Agent',
  'icBonus.hr': 'IC Bonus > Scheme HR',

  'icBonus.disBonus.bonusCharts': 'IC Bonus Distribution > Appointment Type',
  'icBonus.disBonus.bonusCharts.appTypeCode': 'Code',
  'icBonus.disBonus.bonusCharts.l1Percent': 'Percentage (%)',

  'icOverriding.value': 'IC Overriding (%)',
  'icOverriding.icOverriding.disOverridingCode': 'IC Overriding Distribution',
  'icOverriding.disOverridingCode': 'IC Overriding Distribution',
  'icOverriding.agent': 'IC Overriding >  Scheme Agent',
  'icOverriding.hr': 'IC Overriding > Scheme HR',

  'icOverriding.disOverriding.overridingCharts': 'IC Overriding Distribution > Appointment Type',
  'icOverriding.disOverriding.overridingCharts.appTypeCode': 'Code',
  'icOverriding.disOverriding.overridingCharts.l1Percent': 'Percentage (%)',
  'icOverriding.disOverriding.overridingCharts.icWeightage': 'IC Weightage (%)',
  'icOverriding.disOverriding.overridingCharts.poolWeightage': 'Pool Weightage (%)',

  'headHi.value': 'Head of HI > Commission (%)',
  'headHi.disOverridingCode': 'Head of HI > Overriding Distribution',
  'headHi.agent': 'Head of HI >  Scheme Agent',
  'headHi.hr': 'Head of HI > Scheme HR',

  'bd.value': 'BDs > Commission (%)',
  'bd.disOverridingCode': 'BDs > Overriding Distribution',
  'bd.agent': 'BDs >  Scheme Agent',
  'bd.hr': 'BDs > Scheme HR',
  'hiProfit.value': 'HI Company Profit (%)',

};

export const haTransactionFieldsHide = [
  'devGrossComm',
  'hiGrossComm',
  'profomaGrossComm',
  'originalCurrencyCode',
  'originalTransactedPrice',
  'hiProfitAmount',
  'bds',
  'pools',
  'pds',
];
export const transactionFieldsHide = [
  'hiGrossComm.subTotalAmount',
  'hiGrossComm.taxAmount',
  'hiGrossComm.totalAmount',
  'profomaGrossComm.subTotalAmount',
  'referrals.absorbType.agent',
  'referrals.absorbType.hr',
  'referrals.absorbType.full',
  'referrals.absorbType',
  'bds.type',
]

export const fieldNameMapTransaction: { [key: string]: string } = {
  'id': 'ID',
  'code': 'Transaction Code',

  'isActive': 'Status',
  'status': 'Status',

  'projectCode': 'Project Code',
  'optionNo': 'Option No',
  'optionDate': 'Option Date',
  'propertyType': 'Property Type',
  'unitNo': 'Unit No',
  'unit.noOfRooms': 'No of Room',
  'unit.blkNo': 'Blk No',
  'unit.postalCode': 'Postal Code',
  'unit.areaSqft': 'Area Size Sqft',
  'unit.areaSqm': 'Area Size Sqm',
  'landAreaSqft': 'Area Size Sqft',
  'landAreaSqm': 'Area Size Sqm',
  'projectCommission.name': 'Comm Matrix',
  'projectCommInternational.name': 'HI Comm Matrix',
  'originalCurrencyCode': 'Foreign Currency ',
  'originalTransactedPrice': 'Foreign Transacted Price',
  //'currencyCode': 'Currency',
  'transactedPrice': 'Transacted Price (SGD)',
  'isReissue': 'Reissue',
  'reissueDate': 'Reissue Date',
  'eotDate': 'EOT Date',
  'remarks': 'Remarks',
  'buyer.remark': 'Buyer Remark',
  'buyer.remarks': 'Buyer Remarks',
  'metadata.isPendingDCDD': 'Pending DCDD',
  'metadata.isCompleteDCDD': 'Complete DCDD',
  'remarksDcdd': 'DCDD Remarks',

  //Transacted type
  'transactedTypes': 'HA Transacted Types',
  'transactedTypes.type': 'Type',
  'transactedTypes.specifyAmount': 'Specify Amount',
  'transactedTypes.absorbBy': 'Absorb By / Pay To',
  'transactedTypes.rebateBy': 'Buyer Rebate From',
  'transactedTypes.currency': 'Currency',
  'transactedTypes.foreignAmount': 'Foreign Amount',
  'transactedTypes.foreignCurrency': 'Foreign Currency',
  'hiTransactedTypes': 'HI Transacted Types',
  'hiTransactedTypes.type': 'Type',
  'hiTransactedTypes.specifyAmount': 'Specify Amount',
  'hiTransactedTypes.absorbBy': 'Absorb By',
  'hiTransactedTypes.currency': 'Currency',
  'hiTransactedTypes.foreignAmount': 'Foreign Amount',
  'hiTransactedTypes.foreignCurrency': 'Foreign Currency',

  'grossComm.subTotalAmount': 'Gross Comm (excl GST)',
  'grossComm.taxAmount': 'GST',
  'grossComm.totalAmount': 'Gross Comm (incl GST)',
  'devGrossComm.subTotalAmount': 'HI Gross Comm (SGD) (excl GST)',
  'devGrossComm.taxAmount': 'HI GST',
  'devGrossComm.totalAmount': 'Gross Comm (SGD) (incl GST)',
  'devGrossComm.amount': 'HI Dev Comm (SGD)',
  'grossComm.amount': 'HA Comm Amt (SGD)',
  'hiGrossComm.amount': 'HI Comm Amt (SGD)',
  'profomaGrossComm.totalAmount': 'HI Gross Comm (Foreign Amt)',

  // main agent
  'relatedAgent.main': 'Closing Agent',
  'relatedAgent.main.agent.businessName': 'Business Name',
  'relatedAgent.main.agent.ceaRegNo': 'CEA Reg No',
  'relatedAgent.main.attrs': 'Type',
  'relatedAgent.main.receivedPercent': 'Comm (%)',
  'relatedAgent.main.grouping': 'Type',
  'relatedAgent.main.teamType': 'Group Type',
  'relatedAgent.main.team': 'Group',
  'relatedAgent.main.team.name': 'Group Name',
  'relatedAgent.main.attrs.splitForORInvalid': 'Split Comm Manager',

  'relatedAgent.main.transacted.cashAdvance': 'Cash Advance',
  'relatedAgent.main.transacted.cashAdvance.value': 'Cash Advance > Value',
  'relatedAgent.main.transacted.cashAdvance.percent': 'Cash Advance > Percent',
  'relatedAgent.main.transacted.cashAdvance.absorbType.agent': 'Cash Advance > Absorb By Agent',
  'relatedAgent.main.transacted.cashAdvance.absorbType.hr': 'Cash Advance > Absorb By HR',

  'relatedAgent.main.transacted.discount': 'Discount',
  'relatedAgent.main.transacted.discount.value': 'Discount > Value',
  'relatedAgent.main.transacted.discount.percent': 'Discount > Percent',
  'relatedAgent.main.transacted.discount.absorbType.agent': 'Discount > Absorb By Agent',
  'relatedAgent.main.transacted.discount.absorbType.hr': 'Discount > Absorb By HR',
  'relatedAgent.main.transacted.discount.absorbType.full': 'Discount > Absorb By Agent (Full)',

  'relatedAgent.main.transacted.incentive': 'Incentive',
  'relatedAgent.main.transacted.incentive.value': 'Incentive > Value',
  'relatedAgent.main.transacted.incentive.percent': 'Incentive > Percent',
  'relatedAgent.main.transacted.incentive.absorbType.agent': 'Incentive > Absorb By Agent',
  'relatedAgent.main.transacted.incentive.absorbType.hr': 'Incentive > Absorb By HR',
  'relatedAgent.main.transacted.incentive.absorbType.full': 'Incentive > Absorb By Agent (Full)',

  'relatedAgent.main.transacted.buyerRebate': 'Buyer Rebate',
  'relatedAgent.main.transacted.buyerRebate.value': 'Buyer Rebate > Value',
  'relatedAgent.main.transacted.buyerRebate.percent': 'Buyer Rebate > Percent',
  'relatedAgent.main.transacted.buyerRebate.absorbType.agent': 'Buyer Rebate > Absorb By Agent',
  'relatedAgent.main.transacted.buyerRebate.absorbType.hr': 'Buyer Rebate > Absorb By HR',

  'relatedAgent.main.ecddCodes': 'DCDD Ref. No',
  'relatedAgent.main.ecddCodes.code': 'DCDD Ref. No',

  // internal
  'relatedAgent.internals': 'Co-broke > Internal',
  'relatedAgent.internals.agent.businessName': 'Business Name',
  'relatedAgent.internals.agent.ceaRegNo': 'CEA Reg No',
  'relatedAgent.internals.attrs': 'Type',
  'relatedAgent.internals.receivedPercent': 'Comm (%)',
  'relatedAgent.internals.grouping': 'Type',
  'relatedAgent.internals.teamType': 'Group Type',
  'relatedAgent.internals.team': 'Group',
  'relatedAgent.internals.team.name': 'Group Name',
  'relatedAgent.internals.attrs.splitForORInvalid': 'Split Comm Manager',

  'relatedAgent.internals.transacted.cashAdvance': 'Cash Advance',
  'relatedAgent.internals.transacted.cashAdvance.value': 'Cash Advance > Value',
  'relatedAgent.internals.transacted.cashAdvance.percent': 'Cash Advance > Percent',
  'relatedAgent.internals.transacted.cashAdvance.absorbType.agent': 'Cash Advance > Absorb By Agent',
  'relatedAgent.internals.transacted.cashAdvance.absorbType.hr': 'Cash Advance > Absorb By HR',

  'relatedAgent.internals.transacted.discount': 'Discount',
  'relatedAgent.internals.transacted.discount.value': 'Discount > Value',
  'relatedAgent.internals.transacted.discount.percent': 'Discount > Percent',
  'relatedAgent.internals.transacted.discount.absorbType.agent': 'Discount > Absorb By Agent',
  'relatedAgent.internals.transacted.discount.absorbType.hr': 'Discount > Absorb By HR',
  'relatedAgent.internals.transacted.discount.absorbType.full': 'Discount > Absorb By Agent (Full)',

  'relatedAgent.internals.transacted.incentive': 'Incentive',
  'relatedAgent.internals.transacted.incentive.value': 'Incentive > Value',
  'relatedAgent.internals.transacted.incentive.percent': 'Incentive > Percent',
  'relatedAgent.internals.transacted.incentive.absorbType.agent': 'Incentive > Absorb By Agent',
  'relatedAgent.internals.transacted.incentive.absorbType.hr': 'Incentive > Absorb By HR',
  'relatedAgent.internals.transacted.incentive.absorbType.full': 'Incentive > Absorb By Agent (Full)',

  'relatedAgent.internals.transacted.buyerRebate': 'Buyer Rebate',
  'relatedAgent.internals.transacted.buyerRebate.value': 'Buyer Rebate > Value',
  'relatedAgent.internals.transacted.buyerRebate.percent': 'Buyer Rebate > Percent',
  'relatedAgent.internals.transacted.buyerRebate.absorbType.agent': 'Buyer Rebate > Absorb By Agent',
  'relatedAgent.internals.transacted.buyerRebate.absorbType.hr': 'Buyer Rebate > Absorb By HR',

  'relatedAgent.internals.ecddCodes': 'DCDD Ref. No',
  'relatedAgent.internals.ecddCodes.code': 'DCDD Ref. No',

  // externals
  'relatedAgent.externals': 'Co-broke > External',
  'relatedAgent.externals.agent.name': 'External Co-broke > Name',
  'relatedAgent.externals.agent.code': 'External Co-broke > Code',
  'relatedAgent.externals.brokerName': 'Salesperson Name (CEA No)',
  'relatedAgent.externals.brokerPhone.countryCode': 'Salesperson Contact No. > Country Code',
  'relatedAgent.externals.brokerPhone.phoneNumber': 'Salesperson Contact No. > Phone Number',
  'relatedAgent.externals.attrs': 'Type',
  'relatedAgent.externals.receivedPercent': 'Comm (%)',
  'relatedAgent.externals.grouping': 'Type',
  'relatedAgent.externals.teamType': 'Group Type',
  'relatedAgent.externals.team': 'Group',
  'relatedAgent.externals.team.name': 'Group Name',

  'relatedAgent.externals.transacted.cashAdvance': 'Cash Advance',
  'relatedAgent.externals.transacted.discount': 'Discount',
  'relatedAgent.externals.transacted.incentive': 'Incentive',
  'relatedAgent.externals.transacted.buyerRebate': 'Buyer Rebate',
  'relatedAgent.externals.transacted.cashAdvance.value': 'Cash Advance > Value',
  'relatedAgent.externals.transacted.cashAdvance.percent': 'Cash Advance > Percent',
  'relatedAgent.externals.transacted.cashAdvance.absorbType.agent': 'Cash Advance > Absorb By Agent',
  'relatedAgent.externals.transacted.cashAdvance.absorbType.hr': 'Cash Advance > Absorb By HR',

  'relatedAgent.externals.transacted.discount.value': 'Discount > Value',
  'relatedAgent.externals.transacted.discount.percent': 'Discount > Percent',
  'relatedAgent.externals.transacted.discount.absorbType.agent': 'Discount > Absorb By Agent',
  'relatedAgent.externals.transacted.discount.absorbType.hr': 'Discount > Absorb By HR',
  'relatedAgent.externals.transacted.discount.absorbType.full': 'Discount > Absorb By Agent (Full)',

  'relatedAgent.externals.transacted.incentive.value': 'Incentive > Value',
  'relatedAgent.externals.transacted.incentive.percent': 'Incentive > Percent',
  'relatedAgent.externals.transacted.incentive.absorbType.agent': 'Incentive > Absorb By Agent',
  'relatedAgent.externals.transacted.incentive.absorbType.hr': 'Incentive > Absorb By HR',
  'relatedAgent.externals.transacted.incentive.absorbType.full': 'Incentive > Absorb By Agent (Full)',

  'relatedAgent.externals.transacted.buyerRebate.value': 'Buyer Rebate > Value',
  'relatedAgent.externals.transacted.buyerRebate.percent': 'Buyer Rebate > Percent',
  'relatedAgent.externals.transacted.buyerRebate.absorbType.agent': 'Buyer Rebate > Absorb By Agent',
  'relatedAgent.externals.transacted.buyerRebate.absorbType.hr': 'Buyer Rebate > Absorb By HR',

  // leader
  'relatedAgent.leaders': 'Group Leader',
  'relatedAgent.leaders.agent.businessName': 'Business Name',
  'relatedAgent.leaders.agent.ceaRegNo': 'CEA Reg No',
  'relatedAgent.leaders.receivedPercent': 'Comm',
  'relatedAgent.leaders.team.name': 'Group Name',
  //bds
  'bds': 'HI',
  'bds.appTypeCode': 'Appointment Type Code',
  'bds.salesperson.businessName': 'Business Name',
  'bds.salesperson.ceaRegNo': 'CEA Reg No',
  'bds.receivedPercent': 'Comm (%)',

  'bdExternals': 'ECBs',
  'bdExternals.contact.name': 'Company Name',
  'bdExternals.type': 'Type',
  'bdExternals.brokerName': 'Name',
  'bdExternals.brokerPhone': 'Contact',
  'bdExternals.brokerPhone.countryCode': 'Contact > Country Code',
  'bdExternals.brokerPhone.phoneNumber': 'Contact > Phone Number',
  'bdExternals.receivedPercent': 'Comm (%)',
  'bdExternals.transacted': 'Transacted',
  'bdExternals.transacted.discount.value': 'Discount > Value',
  'bdExternals.transacted.discount.percent': 'Discount > Percent',

  'bdExternals.transacted.incentive.value': 'Incentive > Value',
  'bdExternals.transacted.incentive.percent': 'Incentive > Percent',

  //bonus
  'bonuses': 'IC Bonus',
  'bonuses.appTypeCode': 'Appointment Type Code',
  'bonuses.salesperson.businessName': 'Business Name',
  'bonuses.salesperson.ceaRegNo': 'CEA Reg No',
  'bonuses.receivedPercent': 'Comm (%)',
  //comm
  'overridings': 'IC Comm',
  'overridings.appTypeCode': 'Appointment Type Code',
  'overridings.salesperson.businessName': 'Business Name',
  'overridings.salesperson.ceaRegNo': 'CEA Reg No',
  'overridings.receivedPercent': 'Comm (%)',
  //pool
  'pools': 'Pool',
  'pools.appTypeCode': 'Appointment Type Code',
  'pools.salesperson.businessName': 'Business Name',
  'pools.salesperson.ceaRegNo': 'CEA Reg No',
  'pools.receivedPercent': 'Share (%)',
  'pools.isActive': 'Chosen',
  'pools.effectiveDate': 'Effective Date',

  //referrals
  'referrals': 'Referrals',
  'referrals.formula': 'Type',
  'referrals.type': 'Referral Type',
  'referrals.salesperson.businessName': 'Business Name',
  'referrals.salesperson.ceaRegNo': 'CEA Reg No',
  'referrals.agent.name': 'Comm Person',
  'referrals.receivedPercent': 'Comm (%)',

  //bds
  'pds': 'PD',
  'pds.agentType': 'Type',
  'pds.pdRole': 'Type',
  'pds.salesperson.businessName': 'Business Name',
  'pds.salesperson.ceaRegNo': 'CEA Reg No',
  'pds.appTypeCode': 'Appointment Type Code',
  'pds.receivedPercent': 'Comm (%)',

  // buyer
  'buyer': 'Buyer',
  'buyers': 'Buyers Data',
  'buyers.name': 'Name',
  'buyers.type': 'Type',
  'buyers.propertyType': 'Property Type',
  'buyers.nricNo': 'NRIC No/ Passport/ UEN',
  'buyers.yearOfBirth': 'Year of Birth',
  'buyers.gender': 'Gender',
  'buyers.marital.name': 'Marital',
  'buyers.address.postal': 'Postal Code',
  'buyers.address.address': 'Address',
  'buyers.address.addressLine1': 'Address Line 1',
  'buyers.address.addressLine2': 'Address Line 2',
  'buyers.address.addressLine3': 'Address Line 3',
  'buyers.district.name': 'District',
  'buyers.citizen': 'Nationality 1',
  'buyers.nationality': 'Nationality 2',
  'buyers.mobile.countryCode': 'Contact No > Country Code',
  'buyers.mobile.phoneNumber': 'Contact No	> Phone Number',
  'buyers.email': 'Email Address',
  'buyers.occupation': 'Occupation',
  'buyers.ownership': 'No of properties',
  'buyers.isHdbOwnership': 'Current HDB Ownership',
  'buyers.purposeOfPurchase': 'Purpose of Purchase',
};

export const fieldNameMapTransactionBuyer: { [key: string]: string } = {
  'transactionCode': 'Transaction Code',
  'blankFormCode': 'Blank Form Code',
  'buyers': 'Buyers Data',
  'name': 'Name',
  'type': 'Type',
  'propertyType': 'Property Type',
  'nricNo': 'NRIC No/ Passport/ UEN',
  'yearOfBirth': 'Year of Birth',
  'gender': 'Gender',
  'marital.name': 'Marital',
  'address.postal': 'Postal Code',
  'address.address': 'Address',
  'address.addressLine1': 'Address Line 1',
  'address.addressLine2': 'Address Line 2',
  'address.addressLine3': 'Address Line 3',
  'district.name': 'District',
  'citizen': 'Nationality 1',
  'nationality': 'Nationality 2',
  'mobile.countryCode': 'Contact No > Country Code',
  'mobile.phoneNumber': 'Contact No	> Phone Number',
  'email': 'Email Address',
  'occupation': 'Occupation',
  'ownership': 'No of properties',
  'isHdbOwnership': 'Current HDB Ownership',
  'purposeOfPurchase': 'Purpose of Purchase',
}

export const blankFormFieldsHide = [
  'summary.otherFundAmount',
  'devGrossComm.amount',
  'hiGrossComm.amount',
  'profomaGrossComm.totalAmount',
  'pds.tiers.0.percentage',
  'pds.tiers.1.value',
  'pds.tiers.2.value',
  'pds.parties.0.value',
  'pools.tiers.0.percentage',
  'pools.tiers.1.value',
  'pools.tiers.2.value',
  'pools.parties.0.value',
  'referrals.tiers.0.percentage',
];
export const blankFormAdjFieldsHide = [
  'profomaGrossComm.subTotalAmount',
  'devGrossComm.subTotalAmount',
  'devGrossComm.taxAmount',
  'devGrossComm.totalAmount',
  'hiGrossComm.subTotalAmount',
  'hiGrossComm.taxAmount',
  'hiGrossComm.totalAmount',
  'grossComm.subTotalAmount',
  'grossComm.taxAmount',
  'grossComm.totalAmount',
];

export const fieldNameMapBlankForm: { [key: string]: string } = {
  'id': 'ID',
  'code': 'Blank Form Code',
  'transactionCode': 'Transaction Reference No',
  'blankFormCode': 'Blank Form Reference No',
  'batchCode': 'Batch Code',
  'isActive': 'Status',
  'status': 'Status',
  'projectCode': 'Project Code',
  'optionNo': 'Option No',
  'optionDate': 'Option Date',
  'propertyType': 'Property Type',
  'address': 'Address',
  'unitNo': 'Unit No',
  'unit.noOfRooms': 'No of Room',
  'unit.blkNo': 'Blk No',
  'unit.postalCode': 'Postal Code',
  'unit.areaSqft': 'Area Size Sqft',
  'unit.areaSqm': 'Area Size Sqm',
  'landAreaSqft': 'Area Size Sqft',
  'landAreaSqm': 'Area Size Sqm',
  'projectCommission.name': 'Comm Matrix',
  'projectCommInternational.name': 'HI Comm Matrix',
  'originalCurrencyCode': 'Foreign Currency ',
  'originalTransactedPrice': 'Foreign Transacted Price',
  //'currencyCode': 'Currency',
  'transactedPrice': 'Transacted Price (SGD)',
  'isReissue': 'Reissue',
  'reissueDate': 'Reissue Date',
  'eotDate': 'EOT Date',
  'remarks': 'Remarks',
  'buyer.remark': 'Buyer Remark',
  'buyer.remarks': 'Buyer Remarks',
  'metadata.isPendingDCDD': 'Pending DCDD',
  'metadata.isCompleteDCDD': 'Complete DCDD',
  'remarksDcdd': 'DCDD Remarks',

  //Transacted type
  'transactedTypes': 'HA Transacted Types',
  'transactedTypes.type': 'Type',
  'transactedTypes.specifyAmount': 'Specify Amount',
  'transactedTypes.absorbBy': 'Absorb By / Pay To',
  'transactedTypes.rebateBy': 'Buyer Rebate From',
  'transactedTypes.currency': 'Currency',
  'transactedTypes.foreignAmount': 'Foreign Amount',
  'transactedTypes.foreignCurrency': 'Foreign Currency',
  'hiTransactedTypes': 'HI Transacted Types',
  'hiTransactedTypes.type': 'Type',
  'hiTransactedTypes.specifyAmount': 'Specify Amount',
  'hiTransactedTypes.absorbBy': 'Absorb By',
  'hiTransactedTypes.currency': 'Currency',
  'hiTransactedTypes.foreignAmount': 'Foreign Amount',
  'hiTransactedTypes.foreignCurrency': 'Foreign Currency',

  'profomaGrossComm.subTotalAmount': 'HI Gross Comm (Foreign Amount)',
  'devGrossComm.subTotalAmount': 'HI Gross Comm (SGD) (excl GST)',
  'devGrossComm.taxAmount': 'HI GST',
  'devGrossComm.totalAmount': 'HI Gross Comm (SGD) (incl GST)',
  'hiGrossComm.subTotalAmount': 'HI Portion Gross Comm (SGD) (excl GST)',
  'hiGrossComm.taxAmount': 'HI Portion GST',
  'hiGrossComm.totalAmount': 'HI Portion Gross Comm (SGD) (incl GST)',
  'grossComm.subTotalAmount': 'HA Portion Gross Comm (excl GST)',
  'grossComm.taxAmount': 'HA Portion GST',
  'grossComm.totalAmount': 'HA Portion Gross Comm (incl GST)',
  'hiProfitAmount': 'HI Company Profit Amount',

  // 'devGrossComm.amount': 'HI Dev Comm (SGD)',
  // 'grossComm.amount': 'HA Comm Amt (SGD)',
  // 'hiGrossComm.amount': 'HI Comm Amt (SGD)',

  // main agent
  'relatedAgent': 'Agents',
  'relatedAgent.mains': 'Closing Agent',
  'relatedAgent.mains.attrs': 'Type',
  'relatedAgent.mains.grouping': 'Type',
  ...fieldNameAgent('relatedAgent.mains'),
  'relatedAgent.mains.receivedPercent': 'Comm (%)',
  'relatedAgent.mains.teamType': 'Group Type',
  'relatedAgent.mains.team': 'Group',
  'relatedAgent.mains.team.name': 'Group Name',
  'relatedAgent.mains.ecddCodes': 'DCDD Ref. No',
  'relatedAgent.mains.ecddCodes.code': 'DCDD Ref. No',

  // internal
  'relatedAgent.internals': 'Co-broke > Internal',
  'relatedAgent.internals.attrs': 'Type',
  'relatedAgent.internals.grouping': 'Type',
  ...fieldNameAgent('relatedAgent.internals'),
  'relatedAgent.internals.receivedPercent': 'Comm (%)',
  'relatedAgent.internals.teamType': 'Group Type',
  'relatedAgent.internals.team': 'Group',
  'relatedAgent.internals.team.name': 'Group Name',
  'relatedAgent.internals.ecddCodes': 'DCDD Ref. No',
  'relatedAgent.internals.ecddCodes.code': 'DCDD Ref. No',

  // externals
  'relatedAgent.externals': 'Co-broke > External',
  'relatedAgent.externals.agent.name': 'External Co-broke > Name',
  'relatedAgent.externals.agent.code': 'External Co-broke > Code',
  'relatedAgent.externals.brokerName': 'Salesperson Name (CEA No)',
  'relatedAgent.externals.brokerPhone.countryCode': 'Salesperson Contact No. > Country Code',
  'relatedAgent.externals.brokerPhone.phoneNumber': 'Salesperson Contact No. > Phone Number',
  'relatedAgent.externals.attrs': 'Type',
  'relatedAgent.externals.receivedPercent': 'Comm (%)',
  'relatedAgent.externals.receivedValue': 'Comm Amount (Excl GST)',
  'relatedAgent.externals.grouping': 'Type',
  'relatedAgent.externals.teamType': 'Group Type',
  'relatedAgent.externals.team': 'Group',
  'relatedAgent.externals.team.name': 'Group Name',


  // leader
  'relatedAgent.leaders': 'Group Leader',
  ...fieldNameAgent('relatedAgent.leaders'),

  //bds
  'bds': 'HI',
  ...fieldNameAgent('bds'),

  'bdExternals': 'ECBs',
  'bdExternals.contact.name': 'Company Name',
  'bdExternals.type': 'Type',
  'bdExternals.brokerName': 'Name',
  'bdExternals.brokerPhone': 'Contact',
  'bdExternals.brokerPhone.countryCode': 'Contact > Country Code',
  'bdExternals.brokerPhone.phoneNumber': 'Contact > Phone Number',
  'bdExternals.receivedPercent': 'Comm (%)',
  'bdExternals.receivedValue': 'Comm Amount',
  'bdExternals.transacted': 'Transacted',

  //bonus
  'bonuses': 'IC Bonus',
  ...fieldNameAgent('bonuses'),
  //comm
  'overridings': 'IC Comm',
  ...fieldNameAgent('overridings'),
  //pool
  'pools': 'Pools',
  ...fieldNameAgent('pools'),
  'pools.tiers.0.salesperson.businessName': 'Business Name',
  'pools.tiers.0.salesperson.ceaRegNo': 'CEA Reg No',
  'pools.tiers.0.value': 'Comm Amount',
  //bds
  'pds': 'PD',
  'pds.agentType': 'Type',
  'pds.pdRole': 'Type',
  'pds.appTypeCode': 'Appointment Type Code',
  'pds.receivedPercent': 'Comm Amount',
  ...fieldNameAgent('pds'),
  'pds.tiers.0.salesperson.businessName': 'Business Name',
  'pds.tiers.0.salesperson.ceaRegNo': 'CEA Reg No',
  'pds.tiers.0.value': 'Comm Amount',

  //referrals
  'referrals': 'Referrals',
  ...fieldNameAgent('referrals'),
  'referrals.absorbType.agent': 'Scheme Agent',
  'referrals.absorbType.hr': 'Scheme HR',
  'others': 'Others Fee',
  'others.code': 'Code',
  'others.name': 'Type',
  'others.receivedValue': 'Comm Amount',

  'agentTierProfit': 'Agent Tier Profit',
  'companyTierProfit': 'Company Tier Profit',
  'haTierProfit': 'Ultimate Profit',

  // buyer
  'buyer': 'Buyer',
  'buyers': 'Buyers Data',
  'buyers.name': 'Name',
  'buyers.type': 'Type',
  'buyers.propertyType': 'Property Type',
  'buyers.nricNo': 'NRIC No/ Passport/ UEN',
  'buyers.yearOfBirth': 'Year of Birth',
  'buyers.gender': 'Gender',
  'buyers.marital.name': 'Marital',
  'buyers.address.postal': 'Postal Code',
  'buyers.address.address': 'Address',
  'buyers.address.addressLine1': 'Address Line 1',
  'buyers.address.addressLine2': 'Address Line 2',
  'buyers.address.addressLine3': 'Address Line 3',
  'buyers.district.name': 'District',
  'buyers.citizen': 'Nationality 1',
  'buyers.nationality': 'Nationality 2',
  'buyers.mobile.countryCode': 'Contact No > Country Code',
  'buyers.mobile.phoneNumber': 'Contact No	> Phone Number',
  'buyers.email': 'Email Address',
  'buyers.occupation': 'Occupation',
  'buyers.ownership': 'No of properties',
  'buyers.isHdbOwnership': 'Current HDB Ownership',
  'buyers.purposeOfPurchase': 'Purpose of Purchase',
};
export const batchingFieldsHide = [
  'devGrossComm.amount',
  'grossComm.amount',
  'hiGrossComm.amount',
  'hiGrossComm',
  'address.postal',
  'address.country',
  'address.unit',
  'address.house',
  'address.floor',
  'address.street',
  'address.district',
  'address.buildingName',
  'address.noOfRooms',
  'address.building',
  'address.block',
  'address.state',
  'address.city',
  'hiGrossComm.subTotalAmount',
  'hiGrossComm.taxAmount',
  'hiGrossComm.totalAmount',
  'profomaGrossComm.subTotalAmount',
]

export const BATCHING_FIELDS_ALIGN: IAuditTrailAlignField[] = [
  { fieldName: 'details', key: 'transactionCode', typeKey: 'string' },
  { fieldName: 'detailBlankForms', key: 'blankFormCode', typeKey: 'string' },
];

export const fieldNameMapBatching: { [key: string]: string } = {
  'id': 'ID',
  'code': 'Batch Code',
  'name': 'Batch Name',
  'projectCode': 'Project Code',
  'batchName': 'Batch Name',
  'company.name': 'Company',
  'batchComments': 'Batch Comments',
  'customerName': 'Customer Name',
  'invoiceAt': 'Invoice Date',
  'currency': 'Currency',
  'totalAmount': 'Proforma Invoice Amount',
  'isActive': 'Status',
  'status': 'Status',
  'submittedAt': 'Batch Date',
  'submittedBy': 'Batch By',
  'submittedBy.name': 'Batch By',
  'type': 'Type',
  'comments': 'Comments',
  'runAt': 'Scheduled Date',
  'actualComm': 'Total Actual Comm (SGD)',
  'details': 'Transaction Selection',
  'details.transactionCode': 'Transaction Code',
  'details.remarks': 'Remarks',
  'detailBlankForms': 'Blank Form Selection',
  'detailBlankForms.blankFormCode': 'Blank Form Code',
  'detailBlankForms.remarks': 'Remarks',
  'history': 'History',
  'history.transactionCode': 'Transaction No',
  'history.unitNo': 'Unit No',
  'history.isChosenTransaction': 'Chosen',
  'remarks': 'Remarks',

  'country': 'Country',
  'address.address': 'Address',
  'address.addressLine1': 'Address Line 1',
  'address.addressLine2': 'Address Line 2',
  'address.addressLine3': 'Address Line 3',
  'address.postal': 'Postal Code',
  'address.country': 'Country',
  'address.unit': 'Unit',
  'address.house': 'Block No',
  'address.floor': 'Floor',
  'address.street': 'Street',
  'address.district': 'District',
  'address.buildingName': 'Building Name',

  'address.noOfRooms': 'No Of Rooms',
  'address.building': 'Building Name',
  'address.block': 'Block No',
  'address.state': 'State',
  'address.city': 'City',
  'grossComm': 'Billing Amount',
  'grossComm.subTotalAmount': 'Billing Amount (Exc GST)',
  'grossComm.taxAmount': 'GST Amount',
  'grossComm.totalAmount': 'Billing Amount (Inc GST)',

  'devGrossComm': 'Billing Amount',
  'devGrossComm.subTotalAmount': 'Billing Amount (Exc GST)',
  'devGrossComm.taxAmount': 'GST Amount',
  'devGrossComm.totalAmount': 'Billing Amount (Inc GST)',
  'profomaGrossComm.totalAmount': 'Proforma Invoice Amount',
  'profomaGrossComm': 'Proforma Invoice',

};

export const fieldNameMapNoReminder: { [key: string]: string } = {
  'agent': 'Agent',
  'ceaNo': 'CEA No',
  'contactNo': 'Contact No',
  'email': 'Email Address',
  'isActive': 'No Reminder',
}

export const RECORD_TYPES_TRANCACTION: Record<RecordTypesTransaction, OptionDescription<RecordTypesTransaction>> = {
  [RecordTypesTransaction.ProjectEntity]: {
    id: RecordTypesTransaction.ProjectEntity,
    value: RecordTypesTransaction.ProjectEntity,
    name: 'Project Setup',
    viewValue: 'Project Setup',
    fieldNameMap: fieldNameMapProject,
    fieldsHide: [...generalFieldsHide],
  },
  [RecordTypesTransaction.BusinessDirectorEntity]: {
    id: RecordTypesTransaction.BusinessDirectorEntity,
    value: RecordTypesTransaction.BusinessDirectorEntity,
    name: 'Project Setup - HI Tab',
    viewValue: 'Project Setup - HI Tab',
    fieldNameMap: { ...fieldNameMapSetup, ...fieldNameMapTeam },
    fieldsHide: [...generalFieldsHide],
    fieldsAlign: [{ fieldName: 'appTypes', key: 'appTypeCode' }] as IAuditTrailAlignField[]
  },
  [RecordTypesTransaction.UnitEntity]: {
    id: RecordTypesTransaction.UnitEntity,
    value: RecordTypesTransaction.UnitEntity,
    name: 'Project Unit',
    viewValue: 'Project Unit',
    fieldNameMap: fieldNameMapUnit,
    fieldsHide: [...generalFieldsHide, 'projectId']
  },
  [RecordTypesTransaction.KeyAppointmentEntity]: {
    id: RecordTypesTransaction.KeyAppointmentEntity,
    value: RecordTypesTransaction.KeyAppointmentEntity,
    name: 'Key Appointment',
    viewValue: 'Key Appointment',
    fieldNameMap: fieldNameMapSetup,
    fieldsHide: [...generalFieldsHide, 'salesperson.id'],
    fieldsAlign: [{ fieldName: 'appTypes', key: 'appTypeCode' }] as IAuditTrailAlignField[]
  },
  [RecordTypesTransaction.TeamEntity]: {
    id: RecordTypesTransaction.TeamEntity,
    value: RecordTypesTransaction.TeamEntity,
    name: 'Project Consultant',
    viewValue: 'Project Consultant',
    fieldNameMap: fieldNameMapSetup,
    fieldsHide: [...generalFieldsHide]
  },
  [RecordTypesTransaction.TeamMemberEntity]: {
    id: RecordTypesTransaction.TeamMemberEntity,
    value: RecordTypesTransaction.TeamMemberEntity,
    name: 'Project Consultant Member',
    viewValue: 'Project Consultant Member',
    fieldNameMap: { ...fieldNameMapSetup, ...fieldNameMapTeam },
    fieldsHide: [...generalFieldsHide]
  },
  [RecordTypesTransaction.ReferralEntity]: {
    id: RecordTypesTransaction.ReferralEntity,
    value: RecordTypesTransaction.ReferralEntity,
    name: 'Referral',
    viewValue: 'Referral',
    fieldNameMap: { ...fieldNameMapSetup, ...fieldNameMapTeam },
    fieldsHide: [...generalFieldsHide]
  },
  [RecordTypesTransaction.ProjectCommissionEntity]: {
    id: RecordTypesTransaction.ProjectCommissionEntity,
    value: RecordTypesTransaction.ProjectCommissionEntity,
    name: 'Commission Matrix',
    viewValue: 'Commission Matrix',
    fieldNameMap: fieldNameMapProjectCommission,
    fieldsHide: [...generalFieldsHide, 'code', 'isActive', 'isLocked', 'icBonus']
  },
  [RecordTypesTransaction.TransactionEntity]: {
    id: RecordTypesTransaction.TransactionEntity,
    value: RecordTypesTransaction.TransactionEntity,
    name: 'Transaction',
    viewValue: 'Transaction',
    fieldNameMap: fieldNameMapTransaction,
    fieldsHide: [...generalFieldsHide, ...transactionFieldsHide],
    fieldsFilterActive: ['pools'],
    fieldsObjectToArray: ['relatedAgent.main'],
    fieldsHideIndex: ['relatedAgent.mains.ecddCodes', 'relatedAgent.main.ecddCodes', 'relatedAgent.internals.ecddCodes']
  },
  [RecordTypesTransaction.TransactionBuyerEntity]: {
    id: RecordTypesTransaction.TransactionBuyerEntity,
    value: RecordTypesTransaction.TransactionBuyerEntity,
    name: 'Transaction Buyer',
    viewValue: 'Transaction Buyer',
    fieldNameMap: fieldNameMapTransactionBuyer,
    fieldsHide: [...generalFieldsHide]
  },
  [RecordTypesTransaction.BlankFormEntity]: {
    id: RecordTypesTransaction.BlankFormEntity,
    value: RecordTypesTransaction.BlankFormEntity,
    name: 'Blank Form',
    viewValue: 'Blank Form',
    fieldNameMap: fieldNameMapBlankForm,
    fieldsHide: [...generalFieldsHide, ...blankFormFieldsHide],
    fieldsFilterActive: ['pools'],
    fieldsObjectToArray: ['relatedAgent.main'],
    fieldsHideIndex: ['relatedAgent.mains.ecddCodes', 'relatedAgent.main.ecddCodes', 'relatedAgent.internals.ecddCodes']
  },
  [RecordTypesTransaction.BlankFormBuyerEntity]: {
    id: RecordTypesTransaction.BlankFormBuyerEntity,
    value: RecordTypesTransaction.BlankFormBuyerEntity,
    name: 'Blank Form Buyer',
    viewValue: 'Blank Form Buyer',
    fieldNameMap: fieldNameMapTransactionBuyer,
    fieldsHide: [...generalFieldsHide]
  },
  [RecordTypesTransaction.BatchEntity]: {
    id: RecordTypesTransaction.BatchEntity,
    value: RecordTypesTransaction.BatchEntity,
    name: 'Batching',
    viewValue: 'Batching',
    fieldNameMap: fieldNameMapBatching,
    fieldsHide: [...generalFieldsHide, ...batchingFieldsHide],
    fieldsAlign: BATCHING_FIELDS_ALIGN
  },
  [RecordTypesTransaction.BatchBlankFormEntity]: {
    id: RecordTypesTransaction.BatchBlankFormEntity,
    value: RecordTypesTransaction.BatchBlankFormEntity,
    name: 'Blank Form Batching',
    viewValue: 'Blank Form Batching',
    fieldNameMap: fieldNameMapBatching,
    fieldsHide: [...generalFieldsHide, ...batchingFieldsHide, 'history.isChosenTransaction'],
    fieldsAlign: BATCHING_FIELDS_ALIGN
  },
  [RecordTypesTransaction.BatchProformaEntity]: {
    id: RecordTypesTransaction.BatchProformaEntity,
    value: RecordTypesTransaction.BatchProformaEntity,
    name: 'Proforma Invoice',
    viewValue: 'Proforma Invoice',
    fieldNameMap: { ...fieldNameMapBatching, 'code': 'Proforma Invoice No' },
    fieldsHide: [...generalFieldsHide, ...batchingFieldsHide],
    fieldsAlign: BATCHING_FIELDS_ALIGN
  },
  [RecordTypesTransaction.ManagementCommEntity]: {
    id: RecordTypesTransaction.ManagementCommEntity,
    value: RecordTypesTransaction.ManagementCommEntity,
    name: 'Management Comm',
    viewValue: 'Management Comm',
    fieldNameMap: fieldNameMapSetup,
    fieldsHide: [...generalFieldsHide, 'isActive']
  },
  [RecordTypesTransaction.PDOverrideEntity]: {
    id: RecordTypesTransaction.PDOverrideEntity,
    value: RecordTypesTransaction.PDOverrideEntity,
    name: 'Management Comm',
    viewValue: 'Management Comm',
    hideFilter: true,
    fieldNameMap: fieldNameMapSetup,
    fieldsHide: [...generalFieldsHide]
  },
  [RecordTypesTransaction.PDReferralEntity]: {
    id: RecordTypesTransaction.PDReferralEntity,
    value: RecordTypesTransaction.PDReferralEntity,
    name: 'Management Comm',
    viewValue: 'Management Comm',
    hideFilter: true,
    fieldNameMap: fieldNameMapSetup,
    fieldsHide: [...generalFieldsHide]
  },
  [RecordTypesTransaction.PDManagementEntity]: {
    id: RecordTypesTransaction.PDManagementEntity,
    value: RecordTypesTransaction.PDManagementEntity,
    name: 'Management Comm',
    viewValue: 'Management Comm',
    hideFilter: true,
    fieldNameMap: fieldNameMapSetup,
    fieldsHide: [...generalFieldsHide]
  },
  [RecordTypesTransaction.AppointmentTypeEntity]: {
    id: RecordTypesTransaction.AppointmentTypeEntity,
    value: RecordTypesTransaction.AppointmentTypeEntity,
    name: 'Appointment Type',
    viewValue: 'Appointment Type',
    fieldNameMap: { ...fieldNameMapSetup, 'configs': 'Appointment Type' },
    fieldsHide: [...generalFieldsHide]
  },
  [RecordTypesTransaction.DisBonusEntity]: {
    id: RecordTypesTransaction.DisBonusEntity,
    value: RecordTypesTransaction.DisBonusEntity,
    name: 'IC Bonus Distribution',
    viewValue: 'IC Bonus Distribution',
    fieldNameMap: fieldNameMapSetup,
    fieldsHide: [...generalFieldsHide, 'bonusCharts.appointmentTypeId', 'status']
  },
  [RecordTypesTransaction.DisOverridingEntity]: {
    id: RecordTypesTransaction.DisOverridingEntity,
    value: RecordTypesTransaction.DisOverridingEntity,
    name: 'IC Overriding Distribution',
    viewValue: 'IC Overriding Distribution',
    fieldNameMap: fieldNameMapSetup,
    fieldsHide: [...generalFieldsHide, 'overridingCharts.appointmentTypeId', 'status']
  },
  [RecordTypesTransaction.CommSchemeEntity]: {
    id: RecordTypesTransaction.CommSchemeEntity,
    value: RecordTypesTransaction.CommSchemeEntity,
    name: 'Comm Scheme Setup',
    viewValue: 'Comm Scheme Setup',
    fieldNameMap: fieldNameMapSetup,
    fieldsHide: [...generalFieldsHide, 'name', 'code', 'tiers.level', 'parties.level']
  },
  [RecordTypesTransaction.ResaleEntity]: {
    id: RecordTypesTransaction.ResaleEntity,
    value: RecordTypesTransaction.ResaleEntity,
    name: 'Resale',
    viewValue: 'Resale',
    fieldNameMap: fieldNameMapResale,
    fieldsHide: [...generalFieldsHide, ...resaleFieldsHide],
    fieldsHideIndex: ['relatedAgent.mains.ecddCodes', 'relatedAgent.main.ecddCodes', 'relatedAgent.internals.ecddCodes']
  },
  [RecordTypesTransaction.ResaleAdjustmentEntity]: {
    id: RecordTypesTransaction.ResaleAdjustmentEntity,
    value: RecordTypesTransaction.ResaleAdjustmentEntity,
    name: 'Resale Adjustment',
    viewValue: 'Resale Adjustment',
    fieldNameMap: fieldNameMapResaleAdj,
    fieldsHide: [...generalFieldsHide, ...resaleFieldsHide, ...resaleAdjFieldsHide],
  },
  [RecordTypesTransaction.NoReminderEntity]: {
    id: RecordTypesTransaction.NoReminderEntity,
    value: RecordTypesTransaction.NoReminderEntity,
    name: 'No Reminder Listing',
    viewValue: 'No Reminder Listing',
    fieldNameMap: fieldNameMapNoReminder,
    fieldsHide: [...generalFieldsHide]
  }
};
